<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="col-lg-12">
    <b-row>
        <b-col style="text-align:center">
          <h3>Recursos / Consignas Orales</h3>
        </b-col>
    </b-row>
    <div class="card">
      <div class="tab-content">
          <div class="d-flex justify-content-between align-items-center mb-4 pl-4">
            <b-pagination class="p-0 m-0"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table">
            </b-pagination>
            <div class="d-flex align-items-center pl-3 mr-auto">
              <label class="p-0 m-0 pr-3 text-purple">Filtrar por tags</label>
              <vue-tags-input
                v-model="taglist"
                :autocomplete-items="tagslist"
                :add-only-from-autocomplete="true"
                @tags-changed="updatelist"
              />
            </div>
            <div class="col-md-3">
              <ResourceSearchs :routeApi="'writtenorals'" ref="searchcomponent"
                :perPage = "perPage"
                :newTags2 = "newTags2"
                @update="onUpdateDataResource"
                @loading="onLoading"
              />
            </div>
            <b-button @click="onNew" variant="success">
              + Añadir
            </b-button>
          </div>
          <div class="row">
            <div class="col-lg-6" style="padding:0 !important;"
            v-for="audio in resources" v-bind:key="audio.ID">
                <div class="row audio-card">
                    <div class="col-lg-12 m-b-5 d-inline-flex align-items-center justify-content-between">
                        <div class="text-muted" style="width:80%">{{audio.NOMBRE}}</div>
                        <div>
                          <button type="button"
                          class="btn btn-icon btn-icon-mini btn-round btn-info"
                          @click="editWrittenOral(audio)">
                              <i class="zmdi zmdi-edit"></i>
                          </button>
                          <button type="button"
                          class="btn btn-icon btn-icon-mini btn-round btn-danger"
                          @click="deleteWrittenOral(audio.ID,'ES')">
                              <i class="fa fa-trash"></i>
                          </button>
                        </div>
                    </div>
                    <div class="col-lg-12 cardtheme">
                        <audio :src="audio[`${'FICHERO_'+languageGlobal}`]" controls="controls"
                        style="width:100%" type="audio/mpeg" preload="preload">
                        </audio>
                    </div>
                </div>
            </div>
          </div>
      </div>
    </div>
  </div>
  <!-- Info modal -->
    <b-modal :id="infoModal.id" size="xl" :title="infoModal.title" hide-footer>
       <div class="modal-body">
              <div class="d-block ">
                <div>
                  <label for="">Título de la consigna oral</label>
                  <b-form-input
                    id="textarea"
                    v-model="selectedItem.NOMBRE"
                    maxlength="255"
                    placeholder="Título de la consigna..."
                    :state="($v.selectedItem.NOMBRE.$dirty && submitted)?
                    !$v.selectedItem.NOMBRE.$error : null"
                    aria-describedby="nombre-feedback"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback id="nombre-feedback">
                    Este campo es requerido.
                  </b-form-invalid-feedback>
                  <br>
                  <hr />
                  <b-row>
                    <b-col style="text-align:center" class="d-flex justify-content-center align-items-center">
                      <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="selectedItem.AUDIOS_ID !== null && selectedItem.AUDIOS_ID !== 0"
                        @click="openResourceWithParam('audios', selectedItem.AUDIOS_ID)"/>
                      <searchaudios v-on:selected="onSelected($event)" idModal="mdlSearchAudio"></searchaudios>
                    </b-col>
                  </b-row>
                  <b-form-invalid-feedback id="textos_id-feedback" style="text-align:center">
                    Debe buscar un Audio existente
                  </b-form-invalid-feedback>
                  <label for="">Audio</label>
                  <audio :src="getTranslation(selectedItem.FICHERO)" controls="controls"
                                style="width:100%" type="audio/mpeg" preload="preload">
                                </audio>
                </div>
                <div>
                  <b-form-input
                    id="textosid"
                    v-model="selectedItem.AUDIOS_ID"
                    :state="($v.selectedItem.AUDIOS_ID.$dirty && submitted)?
                    !$v.selectedItem.AUDIOS_ID.$error : null"
                    aria-describedby="textos_id-feedback"
                    style="display:none"
                  >
                  </b-form-input>
               </div>
              </div>
              <br>
                          <label>Etiquetas</label>
                            <div>
                            <vue-tags-input
                              v-model="tag"
                              :tags="tags"
                              :autocomplete-items="autocompleteItems"
                              @tags-changed="update"
                            />
                          </div>
              <div class="modal-footer">
                <button type="button" @click="save"
                class="btn btn-info btn-round waves-effect">
                  Guardar</button>
                <b-button class="btn btn-default btn-round waves-effect" block
                @click="$bvModal.hide('info-modal')">Cerrar</b-button>
            </div>
        </div>
    </b-modal>
</div>

</template>

<script>
import { required } from 'vuelidate/lib/validators';
import VueTagsInput from '@johmun/vue-tags-input';
import searchaudios from '../audios/SearchAudios.vue';
import ResourceSearchs from '../../../components/panel/ResourceSearchs.vue';
import searchMixin from '../../../mixins/search';
import translationMixin from '../../../mixins/translation';

export default {
  name: 'gridWrittenInstructions',
  mixins: [searchMixin, translationMixin],
  components: { searchaudios, VueTagsInput, ResourceSearchs },
  data() {
    return {
      mounted: null,
      perPage: 20,
      rows: 0,
      submitted: false,
      currentPage: 1,
      resources: [],
      selectedItem: {
        ID: null,
        NOMBRE: null,
        FICHERO: [],
        AUDIOS_ID: null,
        NOMBRE_AUDIO: null,
      },
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      tag: '',
      tags: [],
      newTags: [],
      tagslist: [],
      newTags2: [],
      taglist: '',
      autocompleteItems: [],
    };
  },
  validations: {
    selectedItem: {
      NOMBRE: {
        required,
      },
      AUDIOS_ID: {
        required,
      },
    },
  },
  methods: {
    onSelected(itemSelected) {
      this.selectedItem.FICHERO = itemSelected.FICHERO;
      this.selectedItem.AUDIOS_ID = itemSelected.ID;
      this.selectedItem.NOMBRE_AUDIO = itemSelected.NOMBRE_AUDIO;
      this.$root.$emit('bv::hide::modal', 'mdlSearchAudio');
    },
    onNew() {
      this.submitted = false;
      this.limpiar();
      this.infoModal.title = 'Crear consigna oral';
      this.tag = '';
      this.tags = [];
      this.$root.$emit('bv::show::modal', this.infoModal.id);
    },
    initItems() {
      const url = 'Tags';
      const datos = [];

      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ text: a.NOMBRE, key: a.ID });
        });
        this.autocompleteItems = datos;
      });

      this.loading = false;
    },
    limpiar() {
      this.selectedItem.ID = null;
      this.selectedItem.AUDIOS_ID = null;
      this.selectedItem.NOMBRE = null;
      this.selectedItem.FICHERO = [];
      this.selectedItem.NOMBRE_AUDIO = null;
      this.tag = '';
      this.tags = [];
    },
    listTags() {
      const url = 'Tags';
      const datos = [];
      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ key: a.ID, text: a.NOMBRE });
        });
        this.tagslist = datos;
      });

      this.loading = false;
    },
    update(newTags) {
      this.tags = newTags;
      this.newTags = newTags;
    },
    updatelist(newTags) {
      this.newTags2 = newTags;
      this.getPostData();
    },
    async getExistingTags(idconsigna) {
      const url = `Tagsconsignasorales/findByconsigna/${idconsigna}`;
      const datos = [];
      this.loading = true;

      try {
        this.axios.get(url).then((res) => {
          res.data.forEach((a) => {
            datos.push({ text: a.NOMBRE, key: a.ID });
          });
          this.tags = datos;
        });

        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    editWrittenOral(audioObj) {
      this.selectedItem.ID = audioObj.ID;
      this.selectedItem.NOMBRE = audioObj.NOMBRE;
      this.selectedItem.AUDIOS_ID = audioObj.AUDIOS_ID;
      this.selectedItem.FICHERO = audioObj.FICHERO;
      this.infoModal.title = 'Editar consigna oral';
      this.getExistingTags(audioObj.ID);
      this.$root.$emit('bv::show::modal', this.infoModal.id);
    },
    async deleteWrittenOral(IDparam) {
      const confirmation = await this.$bvModal.msgBoxConfirm('Esta a punto de eliminar una consigna de audio ¿Esta seguro?');
      if (confirmation) {
        this.loading = true;
        const response = await this.axios.post('writtenorals/delete', { ID: IDparam });
        if (response.data.status === 'success') {
          this.loading = false;
          this.$toasted.show('Se elimino la consigna oral seleccionada.', { theme: 'outline', type: 'success', duration: 5000 });
          this.getPostData();
        } else {
          this.loading = false;
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
      }
    },
    info(item, index, button) {
      this.submitted = false;
      this.infoModal.title = 'Editar consigna escrita';
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.selectedItem.ID = item.ID;
      this.selectedItem.AUDIOS_ID = item.AUDIOS_ID;
      this.selectedItem.NOMBRE = item.NOMBRE;
      this.selectedItem.FICHERO = item.FICHERO;
      this.selectedItem.NOMBRE_AUDIO = item.NOMBRE_AUDIO;
      this.$root.$emit('bv::show::modal', this.infoModal.id, button);
    },
    async save() {
      this.submitted = true;
      this.$v.selectedItem.$touch();
      if (this.$v.selectedItem.$anyError) {
        return;
      }
      this.loading = true;
      const textData = {
        ID: this.selectedItem.ID || -1,
        NOMBRE: this.selectedItem.NOMBRE,
        AUDIOS_ID: this.selectedItem.AUDIOS_ID,
      };
      try {
        const response = await this.axios.post('writtenorals/store', textData);
        if (response.data.status === 'success') {
          const bc = new BroadcastChannel('new_resource_writtenorals');
          bc.postMessage({
            ID: response.data.id,
            NOMBRE: this.selectedItem.NOMBRE,
            AUDIOS_ID: this.selectedItem.AUDIOS_ID,
          });

          const url = `Tagsconsignasorales/deleteTags/${response.data.id}`;
          const url2 = 'Tagsconsignasorales/saveTag';

          this.axios.get(url);
          this.newTags.forEach((a) => {
            this.axios.get(`Tags/findTagByName/${a.text}`,
              { name: a.text }).then((resp) => {
              if (resp.data.status === 'success') {
                this.axios.post(url2, { id: resp.data.id, idconsigna: response.data.id });
              } else {
                this.axios.post(url2, { id: a.key, idconsigna: response.data.id });
              }
            });
          });

          this.$toasted.show('Los datos se guardaron satisfactoriamente.', { theme: 'outline', type: 'success', duration: 5000 });
          this.$root.$emit('bv::hide::modal', this.infoModal.id);
          this.limpiar();

          // Auto close if coming from a create event
          if (this.bAutoClose) {
            window.open('', '_self').close();
          }

          this.getPostData();
        } else {
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
        this.loading = false;
      } catch (e) {
        const resp = e;
        if (!resp.body.Ok) {
          this.$toasted.show(resp.body.Message, { theme: 'outline', type: 'error', duration: 5000 });
        }
        this.loading = false;
      }
    },
    async getPostData() {
      this.loading = true;
      try {
        const response = await this.axios.get('writtenorals', {
          params: {
            currentPage: this.currentPage,
            size: this.perPage,
            newTags: this.newTags2,
            resourcetosearch: this.$refs.searchcomponent.resoursetosearch,
          },
        });
        this.rows = response.data.rows;
        this.resources = Object.keys(response.data.results).map(k => response.data.results[k]);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
  },
  async mounted() {
    await this.getPostData();
    this.initItems();
    this.listTags();

    // Open create modal automatically
    const self = this;
    const bc = new BroadcastChannel('new_resource_writtenorals_open');
    bc.onmessage = () => {
      self.bAutoClose = true;
      self.onNew();
    };

    if (this.$route.params.id != null) {
      this.loading = true;
      const response = await this.axios.get('writtenorals/getwrittenoral', {
        params: {
          id: this.$route.params.id,
        },
      });
      const item = response.data;
      this.loading = false;
      this.info(item, null, null);
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.getPostData();
      },
    },
  },
};
</script>

<style>
  .cardtheme {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
  }
  .hover {
    -moz-transition: all 0.5s;
    -o-transition: all 0.5s;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
    width: 120px;
    display: block;
    text-align: right;
    margin-left: 10px;
}
</style>
